export default function FindUs() {
    return (
      <div className="relative py-16 bg-white">
        <div className="hidden absolute top-0 inset-x-0 h-1/2 bg-gray-50 lg:block" aria-hidden="true" />
        <div className="max-w-7xl mx-auto bg-gray-600 lg:bg-transparent lg:px-8">
          <div className="lg:grid lg:grid-cols-12">
            <div className="relative z-10 lg:col-start-2 lg:row-start-1 lg:col-span-5 lg:py-16 lg:bg-transparent">
              <div className="absolute inset-x-0 h-1/2 bg-gray-50 lg:hidden" aria-hidden="true" />
              <div className="max-w-md mx-auto px-4 sm:max-w-3xl sm:px-6 lg:max-w-none lg:p-0">
                <div className="aspect-w-10 aspect-h-6 sm:aspect-w-2 sm:aspect-h-1 lg:aspect-w-1">
                  <iframe className="object-cover object-center rounded-3xl shadow-2xl" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2708.143013119148!2d-122.4426007!3d47.2529067!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x549055a1721a89d1%3A0xf79626c45b33449a!2sCharles%20Kim%20Dentistry%20-%20Downtown%20Tacoma%20Dentist!5e0!3m2!1sen!2sus!4v1660414426707!5m2!1sen!2sus" width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
              </div>
            </div>
  
            <div className="relative bg-gray-900 lg:col-start-4 lg:row-start-1 lg:col-span-8 lg:rounded-3xl lg:grid lg:grid-cols-8 lg:items-center">
              <div className="hidden absolute inset-0 overflow-hidden rounded-3xl lg:block" aria-hidden="true">
                
              </div>
              <div className="relative max-w-md mx-auto py-12 px-4 space-y-6 sm:max-w-3xl sm:py-16 sm:px-6 lg:max-w-none lg:p-0 lg:col-start-4 lg:col-span-6">
                <h2 className="text-2xl tracking-normal font-bold text-white" id="join-heading">
                  Charles Kim Dentistry
                </h2>
                <p className="text-lg text-white">
                    1102 Broadway, Suite #204<br />
                    Tacoma, WA 98402<br /><br />

                    Phone: 253-533-9340<br />
                    Email: <a href="mailto:office@charleskimdentistry.com">office@charleskimdentistry.com</a><br /><br />

                    Hours:<br />
                    Monday: 8:00am – 5:00pm<br />
                    Tuesday: 8:00am – 5:00pm<br />
                    Wednesday: 8:00am – 5:00pm<br />
                    Thursday: 8:00am – 5:00pm<br />
                    Friday: 8:00am - 12:00pm
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  